export const homeFaqs = [
  {
    id: 1,
    question: 'What is the best surfboard ding repair kit?',
    answer: 'The best surfboard ding repair kits cure quickly, work on multiple board types, and are easy to use without experience. PHIX Doctor kits use sun-powered resin that hardens in 1–3 minutes in direct sunlight — no mixing ratios, no UV lamp, and no waiting overnight. Surfers worldwide rate them as the fastest, cleanest DIY repair solution available.',
  },
  {
    id: 2,
    question: 'How long does surfboard repair take with sun-powered resin?',
    answer: 'With PHIX Doctor sun-powered resin, the actual cure time is just 1–3 minutes in direct sunlight. Full prep (cleaning, sanding) and finishing (final sanding, inspection) brings the total time to 10–15 minutes. Most surfers complete the full repair and return to the water within the same session — no drying time, no waiting hours.',
  },
  {
    id: 3,
    question: 'Can I repair my surfboard myself without experience?',
    answer: 'Yes. PHIX Doctor DIY surfboard repair kits are specifically designed for surfers with no repair experience. Every kit includes step-by-step instructions, pre-measured fiberglass patches, and a squeegee tool. The sun-powered resin only activates in UV light, so there\'s no rush — you cure it exactly when you\'re ready. No technical skills required.',
  },
  {
    id: 4,
    question: 'Do PHIX Doctor kits work on epoxy and polyester boards?',
    answer: 'Yes. The Universal SunPowered Kit is formulated to work on both epoxy (EPS foam + epoxy laminate) and polyester (PU foam + poly laminate) surfboards. For surfers who want a formula optimized for their specific board type, we also offer dedicated Epoxy Kits and Polyester Kits for maximum adhesion and clearest finish.',
  },
  {
    id: 5,
    question: 'Can I travel with a PHIX Doctor repair kit on a plane?',
    answer: 'Yes. Our Micro Emergency Kit is specifically designed to be TSA carry-on compliant. Pre-measured resin capsules eliminate spill risk during transport. The compact kit fits in a boardshorts pocket or any backpack. Always verify current airline regulations for resin-based products when traveling internationally, as rules vary by carrier and country.',
  },
  {
    id: 6,
    question: 'How does sun-powered resin work technically?',
    answer: 'PHIX Doctor uses photoinitiated polymer chemistry. The resin contains UV-reactive photoinitiators that trigger rapid cross-linking when exposed to UV wavelengths present in direct sunlight. This creates a strong, waterproof thermoset bond within 1–3 minutes. Unlike traditional resins, no chemical catalyst is required — the resin stays workable until you expose it to sun.',
  },
];

export const productFaqs = [
  {
    id: 1,
    question: 'Will this kit work on my specific board?',
    answer: 'PHIX Doctor universal repair kits are designed to work on both epoxy and polyester surfboards — covering the vast majority of modern boards. For soft-top or foam surfboards, use our dedicated Softboard Repair Kit with flexible compound. If you\'re unsure about your board type, check the manufacturer\'s label or contact our support team for a recommendation.',
  },
  {
    id: 2,
    question: 'How strong and durable is the finished repair?',
    answer: 'When applied correctly following the included instructions, PHIX Doctor repairs restore the full structural integrity of the damaged area. The cured resin bonds directly to the fiberglass laminate, creating a waterproof, impact-resistant repair designed to withstand regular surf conditions, including reef impacts, rocky beaches, and heavy session use.',
  },
  {
    id: 3,
    question: 'What happens if I cure in cloudy weather?',
    answer: 'PHIX Doctor resins will cure under any UV light source, including overcast skies, though at a slower rate than direct sunlight. Bright overcast days typically cure in 5–10 minutes. Full cloud cover may extend this to 15–20 minutes. For guaranteed fast cures in any conditions, any consumer UV flashlight or UV lamp also works effectively.',
  },
  {
    id: 4,
    question: 'How many repairs can I get from one kit?',
    answer: 'A standard PHIX Doctor kit includes enough resin for 4–8 typical repairs, depending on the ding size. The Micro Emergency Kit includes 3 pre-measured capsules for 3 small emergency repairs. For high-volume use or workshops, our Bio-Resin Refill packs provide 4 extra tubes to top up any existing kit.',
  },
];

export const aboutFaqs = [
  {
    id: 1,
    question: 'Why use sun-powered resin over traditional repair methods?',
    answer: 'Sun-powered resin offers dramatically faster curing (1–3 minutes vs 4–12 hours), no toxic catalyst fumes, and zero mixing errors. The resin stays workable until you apply sunlight, giving you full control with no time pressure. Unlike traditional hardener systems, there\'s no risk of wrong ratios causing soft spots or failed repairs.',
  },
  {
    id: 2,
    question: 'Is PHIX Doctor eco-friendly?',
    answer: 'PHIX Doctor actively develops bio-resin formulations using plant-derived ingredients to reduce petrochemical dependency. Current bio-resin lines use sustainable packaging, minimized plastic, and reduced-solvent formulas. The company has a sustainability roadmap targeting 50% bio-sourced resin formulations. Compared to traditional repair systems, PHIX Doctor significantly reduces VOC output per repair.',
  },
  {
    id: 3,
    question: 'Where is PHIX Doctor available globally?',
    answer: 'PHIX Doctor products are distributed through 1,200+ retail locations across 60+ countries. Key markets include the USA, Australia, UK, France, Spain, Portugal, Indonesia, and major surf destinations worldwide. Products are also available for worldwide shipping through multiple online retailers including Amazon, Boardcave, and Cleanline Surf.',
  },
];

export const distributionFaqs = [
  {
    id: 1,
    question: 'Can I travel with a PHIX Doctor repair kit on an airplane?',
    answer: 'Yes. PHIX Doctor Micro Emergency Kits are specifically designed for air travel and are TSA carry-on compliant. Pre-measured resin capsules are sealed to prevent leaks in unpressurized baggage. Most international flights accept these kits in carry-on. Always verify current carrier-specific regulations for resin-based products when booking international surf trips.',
  },
  {
    id: 2,
    question: 'Where can I buy surfboard repair kits near me?',
    answer: 'PHIX Doctor products are available in 1,200+ surf shops across 60+ countries. Use the store finder on this page to locate your nearest retailer. If no local store stocks PHIX Doctor, our online store ships worldwide with fast delivery. Most orders arrive within 2–5 business days depending on your location.',
  },
  {
    id: 3,
    question: 'How do I become a PHIX Doctor stockist or distributor?',
    answer: 'PHIX Doctor welcomes new retail partners globally. We offer competitive wholesale pricing, comprehensive POS display materials, product training, and exclusive territory options in select markets. Use the wholesale enquiry form on this page or email hello@phixdoctor.com with your store details, location, and estimated order volume for a prompt response.',
  },
];
